// extracted by mini-css-extract-plugin
module.exports = {"root":"searchTrigger_root__gv7ow","label":"searchTrigger_label__3Rp2n"};